module.exports = __webpack_public_path__ + "static/stats@2x-4dfe18b20595cc00d181dacf2a48f913.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/cookpad/stats@2x.jpg
// module id = 352
// module chunks = 3627797113349 20562973939449 33019919093843